<template>
  <div id="new-contract-02">
        <SearchBar placeholder="ค้นหารายชื่อ" v-model="nameSearchString"></SearchBar>
        <error-cant-reach-server :errorData="errorData"  class="mt-2 mr-2 ml-2" v-if="isCantReach" @clickCTA="$reloadPage()"></error-cant-reach-server>
        <div v-if="nameSearchString !== ''" class="container pl-4 pr-4 pt-1 pb-2 bg-white text-primary">
            พบ {{contractPersons.length}} คน ที่มีคำว่า "{{nameSearchString}}" ในชื่อ
        </div>
        <div class="container" v-if="contractPersons.length === 0 && nameSearchString === ''"><p class="p-4 text-muted text-center">เริ่มค้นหาผู้ทำสัญญาได้ที่กล่องค้นหาด้านบน</p></div>
        <ul class="list-group list-group-flush" v-for="(person, i) in contractPersons" :key="i">
            <button @click="$router.push({ name: 'new-contract-03', params: { type: $route.params.type }, query: { id: person.id } })" class="list-group-item list-group-item-action d-flex pt-3 pb-3 align-items-center">
                <img class="rounded-circle shadow icon-48" :src="person.avatarPath">
                <p class="ml-3 mb-0">{{person.partial_title}}{{person.name}} {{person.lastname}}</p>
            </button>
        </ul>
        <div class="stick-down-pusher"></div>
        <div class="stick-down p-4 pb-5">
            <router-link class="btn btn-light btn-lg btn-block" :to="{ name: 'new-contract-01' }">ย้อนกลับ</router-link>
        </div>
  </div>
</template>

<script>
import SearchBar from '../../sub_components/SearchBar'

export default {
    data: () => ({
        isCantReach: false,
        errorData: {},
        nameSearchString: '',
        contractPersons: [],
        contractPersonsAll: [],
    }),
    watch: {
        nameSearchString (to) {
            if (to === '') {
                this.contractPersons = []
            } else {
                this.contractPersons = this.contractPersonsAll.filter(
                    elm => elm.name.toLowerCase().includes(to.toLowerCase())
                )
            }
        }
    },
    async created () {
        $('#new-contract-02-sub-header').css('display', 'block')
        const result = await this.$api.contract.listAvailableContractPerson()
        const data = result.data
        if (!data.success) {
            this.isCantReach = true
            this.errorData = data
            return
        }
        this.contractPersonsAll = data.people
        // this.contractPersons = this.contractPersonsAll
    },
    beforeDestroy () {
        $('#new-contract-02-sub-header').css('display', 'none')
    },
    components: {
        SearchBar
    }
};
</script>

<style lang="scss">
</style>
